(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal2/assets/javascripts/place-bet/place-bet-selfservice.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal2/assets/javascripts/place-bet/place-bet-selfservice.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const logger = new svs.core.log.Logger('svs.sport.QuickplayModal');
const {
  CurrencyAsJupiterString
} = svs.utils.format;
const {
  resolveITSProductId
} = svs.utils.products;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  isMarketplaceWallet
} = svs.components.tipsen.wallet.walletHelpers;
const {
  SystemTypes,
  QuickpickProps
} = svs.components.sport.quickplayModal2.helpers;
const NUM_DRAWS = 1;
const ROW_PRICE_MULTI = 1;
const BET_PROPERTIES_MARKETPLACE = 'GROUP';
const BET_PROPERTIES_XPERTEN = 'XPERTEN';
const SYSTEM_NUM_REPLACEMENT_FOR_INCORRECT_DATA_FROM_XPERT_API = 1;
const {
  getPixHandler
} = svs.components.sport.pixHandler;

function _prepareWagerToPay(_ref) {
  let {
    productId,
    wallet,
    isPixMix
  } = _ref;
  const pixHandler = getPixHandler({
    isPixMix
  });
  const {
    drawNumber,
    systemCost
  } = pixHandler.getProduct(productId);
  const wagerBoardData = pixHandler.compose(productId);
  const wagerProductId = resolveITSProductId(productId) || '';
  if (!wagerProductId) {
    logger.info('Warning in placeBet: Sending wager without productID');
  }
  const bet = {
    productId: wagerProductId,
    drawNum: drawNumber,
    numDraws: NUM_DRAWS,
    betAmountSalesGroup1: CurrencyAsJupiterString(systemCost),
    betAmountSalesGroup2: '0,00',
    rowPriceMulti: ROW_PRICE_MULTI,
    betProperties: []
  };
  if (wagerBoardData.fulltraff) {
    bet.scoreBoards = [{
      systemType: SystemTypes.MSYS,
      boardData: wagerBoardData.fulltraff,
      boardProps: [QuickpickProps.WEIGHTEDQP],
      rowPriceMulti: ROW_PRICE_MULTI
    }];
  }
  if (wagerBoardData.bomben) {
    bet.expertenBoardData = {
      eventResults: wagerBoardData.bomben
    };
    bet.betProperties.push(BET_PROPERTIES_XPERTEN);
  }
  if (wagerBoardData.game1X2) {
    bet.game1X2Boards = [{
      boardData: wagerBoardData.game1X2,
      systemType: [SystemTypes.MSYS],
      boardProps: [QuickpickProps.WEIGHTEDQP],
      rowPriceMulti: ROW_PRICE_MULTI,
      numSelections: systemCost,
      systemNum: SYSTEM_NUM_REPLACEMENT_FOR_INCORRECT_DATA_FROM_XPERT_API
    }];
  }
  if (wagerBoardData.maltipset) {
    bet.numberBoards = wagerBoardData.maltipset.map(board => _objectSpread(_objectSpread({}, board), {}, {
      systemType: [SystemTypes.MSYS],
      boardProps: [QuickpickProps.WEIGHTEDQP],
      rowPriceMulti: ROW_PRICE_MULTI,
      systemNum: 1
    }));
  }
  if (wagerBoardData.expertenBoardData) {
    bet.expertenBoardData = wagerBoardData.expertenBoardData;
    bet.betProperties.push(BET_PROPERTIES_XPERTEN);
  }
  if (wagerBoardData.racing) {
    bet.rowPriceMulti = wagerBoardData.racing.rowPriceMulti;
    bet.rxBoards = wagerBoardData.racing.rxBoards;
    bet.subProductId = wagerBoardData.racing.subProductId;
  }
  if (isMarketplaceWallet(wallet)) {
    bet.betProperties.push(BET_PROPERTIES_MARKETPLACE);
  }
  return {
    crc: 0,
    marketInfo: 0,
    bagType: 0,
    bets: [bet],
    drawNum: drawNumber
  };
}

function placeBetSelfService(_ref2) {
  let {
    drawData,
    productId,
    unlockPaymentFlow,
    closeCallback,
    isPixMix
  } = _ref2;
  if (!drawData) {
    unlockPaymentFlow();
    return;
  }
  let regCloseTime;
  if (drawData) {
    regCloseTime = drawData.regCloseTime;
  }
  const pixHandler = getPixHandler({
    isPixMix
  });
  const {
    systemCost
  } = pixHandler.getProduct(productId);
  const {
    generateProductItem,
    getCartInstance
  } = svs.components.selfserviceCart;
  const wagerToPay = _prepareWagerToPay({
    productId,
    wallet: null,
    isPixMix
  });
  let description = '';
  if (regCloseTime) {
    try {
      description = "Spelstopp: ".concat(formatDate(new Date(regCloseTime), true, true));
    } catch (_unused) {
      logger.info("Error parsing regCloseTime \"".concat(regCloseTime, "\""));
    }
  }
  const wagerWrapper = generateProductItem({
    wagers: [wagerToPay],
    headers: {
      source: 'SvS:LB:ITS'
    },
    isLive: false,
    productFlag: productId,
    cost: systemCost,
    description
  });
  getCartInstance().actions.addItem(wagerWrapper, () => {
    pixHandler.fetch({
      productId,
      shouldGenerateNewPix: true
    });
    unlockPaymentFlow();
    if (closeCallback) {
      closeCallback();
    }
  });
}
setGlobal('svs.components.sport.quickplayModal2.placeBet.placeBetSelfService', placeBetSelfService);

 })(window);